import React from "react";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
	title: {
		margin: 0,
		color: theme.mode === "light" ? "#0F172A" : "#F8FAFC",
		fontSize: "1.25rem",
		fontWeight: 750,
		letterSpacing: "-0.025em",
		"&:after": {
			content: '""',
			display: "block",
			width: 34,
			height: 3,
			marginTop: 7,
			borderRadius: 999,
			backgroundColor: theme.palette.primary.main,
		},
	},
}));

export default function Title(props) {
	const classes = useStyles();

	return (
		<Typography variant="h5" className={classes.title}>
			{props.children}
		</Typography>
	);
}
